export class ReportFilterModel {
    UserId: Number = 0;
    RequestNumber: string = '';
    RequestStatus: Number = 0;
    ReqStartDt?: string = '';
    ReqEndDt?: string = '';
    RequestorNames: string = '';
    RequestorEmails: string = '';
    Company: number = 0;    
    Block: number = 0;
    Department: number = 0;
    SubDepartment: number = 0;
    QueryCat: number = 0;
    QuerySubCat: number = 0;
    AFENumber: string = '';
    LetterRefNum: string = '';
    ContractNum: string = '';
    WONum: string = '';
    PriorityLevel: number = 0;
    CreatedBy: string = '';
    CompanyRestricted: number = 0;
    Confidential: number = 0;
    Subject: string = '';
} 